<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">营销系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>申购管理</el-breadcrumb-item>
        </el-breadcrumb>

        <div style="margin-top: 20px">
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="coinType" label="币种"></el-table-column>
                <el-table-column prop="supportCoin" label="支持币种"></el-table-column>
                <el-table-column prop="nowAmount" label="当前数量"></el-table-column>
                <el-table-column prop="totalAmount" label="总数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="price" label="价格"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <span>{{scope.row.status | statusFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="开始时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.startTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="结束时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.endTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleDetail(scope.row.id)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog title="申购注水" :visible.sync="addWalterDialogVisible" width="500px" @close="clearData">
            <span>确认申购注水吗？</span>
            <el-form label-width="60px" :model="addWalterData" :rules="addWalterRules" ref="addWalterForm"
                     style="margin-top: 30px">
                <el-form-item label="数量：" prop="amount">
                    <el-input-number v-model="addWalterData.amount" :min="0" :max="1000000000000" style="width: 80%"
                                     label="数量"></el-input-number>
                </el-form-item>
                <el-form-item label="币种：" prop="coinType">
                    <el-autocomplete class="inline-input" style="width: 80%"
                                     v-model="addWalterData.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="addWalterDialogVisible=false">取 消</el-button>
                <el-button type="danger" @click="addWalter">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="申购详情" :visible.sync="detailDialogVisible" @close="clearDataOne" fullscreen>

            <div>
                <el-button type="danger" @click="handleAddWalter(detailData.id)">注水</el-button>
                <el-button type="danger" @click="handleChecking(detailData.id)">检查</el-button>
                <el-button type="danger" @click="handleCalculate(detailData.id)">计算</el-button>
                <el-button type="danger" @click="handleTrans(detailData.id)">转账</el-button>
            </div>

            <h3 style="border-bottom: 1px solid gray">详情</h3>
            <el-form label-width="150px" inline style="margin-top: 30px">
                <el-form-item label="用户申购数量：" style="margin-right: 30px;width: 300px">{{detailData.userAmount}}
                </el-form-item>
                <el-form-item label="平台申购数量：" style="margin-right: 30px;width: 300px">{{detailData.publicAmount}}
                </el-form-item>
                <el-form-item label="申购币种：" style="margin-right: 30px;width: 300px">{{detailData.purchaseCoin}}
                </el-form-item>
                <el-form-item label="申购总数：" style="margin-right: 30px;width: 300px">{{detailData.totalAmount}}
                </el-form-item>
                <el-form-item label="用户获得代币数量：" style="margin-right: 30px;width: 300px">
                    {{detailData.userTransferAmount}}
                </el-form-item>
                <el-form-item label="平台获得代币数量：" style="margin-right: 30px;width: 300px">
                    {{detailData.publicTransferAmount}}
                </el-form-item>
                <el-form-item label="状态：" style="margin-right: 30px;width: 300px">{{detailData.status | statusFormat}}
                </el-form-item>
                <el-form-item label="支持申购币种：" style="margin-right: 30px">{{detailData.supportCoin}}
                </el-form-item>
                <el-form-item label="发币账户余额" style="margin-right: 30px">{{detailData.balanceAmount}}
                </el-form-item>
            </el-form>

            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" min-height="760"
                      max-height="1500"
                      :data="detailData.orders" :row-key="() => Math.random()">
                <el-table-column prop="id" label="记录ID"></el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="coinAmount" label="得到代币数量"></el-table-column>
                <el-table-column prop="payCoin" label="支付币种"></el-table-column>
                <el-table-column prop="payAmount" label="支付数量"></el-table-column>
                <el-table-column prop="purchaseAmount" label="申购数量"></el-table-column>
                <el-table-column prop="needAmount" label="需要支付代币数量"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <span>{{scope.row.status | orderStatusFormat}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="detailDialogVisible=false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: "PurchaseManage",
        data() {
            return {
                dataList: [], //申购列表
                coinTypes: [],
                total: 0, //总条数
                queryParams: { //查询参数
                    page: 1,
                    size: 10
                },
                addWalterDialogVisible: false,
                addWalterData: {
                    purchaseId: "",
                    amount: "",
                    coinType: ""
                },
                addWalterRules: {
                    "amount": [{required: true, message: "数量不能为空"}],
                    "coinType": [{required: true, message: "币种不能为空"}],
                },
                detailData: {id: ""},
                detailDialogVisible: false
            };
        },
        filters: {
            statusFormat(val) {
                let str = "";
                switch (val) {
                    case 0:
                        str = "未开始";
                        break;
                    case 1:
                        str = "申购中";
                        break;
                    case 2:
                        str = "申购结束";
                        break;
                    case 3:
                        str = "已检查";
                        break;
                    case 4:
                        str = "已计算";
                        break;
                    case 5:
                        str = "已完成";
                        break;
                }
                return str;
            },
            orderStatusFormat(val) {
                let str = "";
                switch (val) {
                    case 0:
                        str = "申购中";
                        break;
                    case 1:
                        str = "已检查";
                        break;
                    case 2:
                        str = "可转账";
                        break;
                    case 3:
                        str = "转账中";
                        break;
                    case 4:
                        str = "成功";
                        break;
                    case 5:
                        str = "失败";
                        break;
                }
                return str;
            }
        },
        methods: {
            getPurchaseList(query) {
                api.getPurchaseList(query).then(({data}) => {
                    this.dataList = data.list;
                    this.total = data.totalCount;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getPurchaseList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getPurchaseList(this.queryParams);
            },
            handleAddWalter(id) {
                this.addWalterData = {purchaseId: id, amount: "", coinType: ""};
                this.addWalterDialogVisible = true;
            },
            addWalter() {
                this.$refs["addWalterForm"].validate(valid => {
                    if (valid) {
                        api.purchaseAddWater(this.addWalterData).then(({data}) => {
                            this.$message.success('操作成功！');
                            this.addWalterDialogVisible = false;
                            this.handleDetail(this.detailData.id);
                        });
                    }
                });
            },
            handleChecking(id) {
                this.$confirm('确认申购检查吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.puchaseChecking({purchaseId: id}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.handleDetail(this.detailData.id);
                    });
                }).catch(() => {
                });
            },
            handleCalculate(id) {
                this.$confirm('确认申购计算吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.calculatePurchase({purchaseId: id}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.handleDetail(this.detailData.id);
                    });
                }).catch(() => {
                });
            },
            handleTrans(id) {
                this.$confirm('确认申购转账吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.transPurchase({purchaseId: id}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.handleDetail(this.detailData.id);
                    });
                }).catch(() => {
                });
            },
            handleDetail(id) {
                api.getPurchaseOrder({purchaseId: id}).then(({data}) => {
                    this.detailData = {id: id, ...data};
                    this.coinTypes = data.supportCoin ? data.supportCoin.split(",") : [];
                    this.detailDialogVisible = true;
                });
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.addWalterData.coinType = '';
            },
            clearData() {
                this.addWalterData = {purchaseId: "", amount: "", coinType: ""};
            },
            clearDataOne() {
                this.coinTypes = [];
                this.detailData = {id: ""};
                this.getPurchaseList(this.queryParams);
            }
        },
        created() {
            this.getPurchaseList(this.queryParams);
        }
    }
</script>

<style scoped>

</style>